import "./loading.css";

function Loading() {
    return (
        <div className="loading new-order">
            Loading...
        </div>
    )
}

export default Loading;